import { embeddedBrowserAvailabilityStore, type EmbeddedBrowserAvailabilityStore } from "./availability"
import { embeddedBrowserStore } from "./store"
import { installEmbeddedBrowserTools } from "./tools"

interface EmbeddedBrowserCapabilityCoordinatorOptions {
    availability?: EmbeddedBrowserAvailabilityStore
    installTools?: () => () => void
    stopBrowser?: () => void
}

/** Registers one stable Browser manifest whenever this renderer has the native capability. */
export function installEmbeddedBrowserCapabilityCoordinator(options: EmbeddedBrowserCapabilityCoordinatorOptions = {}): () => void {
    const availability = options.availability ?? embeddedBrowserAvailabilityStore
    const installTools = options.installTools ?? installEmbeddedBrowserTools
    const stopBrowser = options.stopBrowser ?? (() => embeddedBrowserStore.stopSession())
    if (!availability.available) {
        stopBrowser()
        return () => undefined
    }

    const disposeTools = installTools()

    return () => {
        disposeTools()
    }
}
